import {
  Box,
  Button,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Grid,
} from "@mui/material";
import { useState, useEffect } from "react";

const BulkSMSSelector = ({ passengers, onSendMessage }) => {
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [checked, setChecked] = useState([]);
  const [bulkMessage, setBulkMessage] = useState("");
  const [title, setTitle] = useState("");
  const [leftSearch, setLeftSearch] = useState("");
  const [rightSearch, setRightSearch] = useState("");
  const [selectedType, setSelectedType] = useState("USER");
  const leftChecked = checked.filter((value) => left.includes(value));
  const rightChecked = checked.filter((value) => right.includes(value));

 useEffect(() => {
    if (passengers && passengers.length > 0) {
    const filtered = passengers.filter((p) => p.row.userType === selectedType);
    setLeft(filtered);
    setRight([]);
    setChecked([]);
    }
  }, [passengers, selectedType]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
     setChecked([...checked, ...left]); 
    setLeft([]);
    
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
     setChecked([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(left.filter((value) => !leftChecked.includes(value)));
    setChecked(checked.filter((value) => leftChecked.includes(value)));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(right.filter((value) => !rightChecked.includes(value)));
    setChecked(checked.filter((value) => !rightChecked.includes(value)));
  };

  const handleSend = () => {
    const selecteddatas = right.map((passenger) => ({
      id: passenger.row._id,
      name: passenger.row.user_name,
      devicetoken : passenger.row.deviceToken,
      email: passenger.email,
    }));

    if (onSendMessage) {
      onSendMessage(selecteddatas, bulkMessage , title);
    }
    setTitle("");
    setBulkMessage("");
    setRight([]);
    setLeft(passengers);
  };

  const customList = (items, searchValue, setSearchValue) => {
    const filteredItems = items.filter((item) =>
      item.row.user_name.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.email.toString().includes(searchValue)
    );

    return (
      <Box>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Search..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          sx={{ mb: 1 }}
        />
        <List
          dense
          sx={{
            width: 300,
            height: 230,
            overflow: "auto",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        >
          {filteredItems.map((value) => {
            const labelId = `transfer-list-item-${value.row._id}-label`;

            return (
              <ListItem key={value.row._id} button onClick={handleToggle(value)}>
                <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={`${value.row.user_name} (${value.email})`}
                />
              </ListItem>
            );
          })}
        </List>
      </Box>
    );
  };

  return (
    <Box sx={{ padding: 2 }}>
<Box display="flex" alignItems="center" mb={2} gap={1}>
  <Button
    variant={selectedType === "USER" ? "contained" : "text"}
    size="small"
    onClick={() => setSelectedType("USER")}
  >
    Select Passengers
  </Button>
  <Typography variant="body1">/</Typography>
  <Button
    variant={selectedType === "DRIVER" ? "contained" : "text"}
    size="small"
    onClick={() => setSelectedType("DRIVER")}
  >
    Select Drivers
  </Button>
</Box>

      <Box display="flex" justifyContent="space-between" mb={2}>
        <Button onClick={handleAllRight} variant="contained" color="primary" size="small">
          Select All
        </Button>
        <Button onClick={handleAllLeft} variant="contained" color="warning" size="small">
          Clear All
        </Button>
      </Box>

      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item>{customList(left, leftSearch, setLeftSearch)}</Grid>

        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              sx={{ mb: 1 }}
            >
              &gt;
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
            >
              &lt;
            </Button>
          </Grid>
        </Grid>

        <Grid item>{customList(right, rightSearch, setRightSearch)}</Grid>
      </Grid>

      <Typography variant="h6" sx={{ mt: 4 }}>
        Title
      </Typography>

<TextField
  fullWidth
  value={title}
  onChange={(e) => setTitle(e.target.value)}
  placeholder="Write your Title here"
/>

      <Typography variant="h6" sx={{ mt: 4 }}>
        Message
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={4}
        value={bulkMessage}
        onChange={(e) => setBulkMessage(e.target.value)}
        placeholder="Write your message here"
      />

      <Box display="flex" justifyContent="flex-end" gap={2} mt={2}  >
        <Button onClick={handleSend} variant="contained" color="success" sx={{ color:"#fff" }} 
         disabled={right.length === 0 || bulkMessage.trim() === "" || title.trim() === "" }
        >
          ✓ Send Notifications
        </Button>
      </Box>
    </Box>
  );
};

export default BulkSMSSelector;
